<template>
    <div :class="{mb: isMobile}">
        <!-- Technical -->
        <section class="technical hover-anim" v-animate="'fade-in'">
            <div class="container border-bottom">
                <h5 class="sub_title">
                    <animation-sub-title :title="'インフラ、セキュリティ、開発、多言語を複数国一括で対応'" :id="'title-1'"/>
                </h5>
                <p class="sub_content">自動車メーカー、大手リテール企業の運用で培ったwebサイトのインフラ環境構築からWebサイト制作・運用まで幅広く提案しております。<br/>
                    既に構築されたWebサイトのメンテナンスやアクセス解析パートのみでもご相談いただけます。</p>
                <div class="img-area icon-list">
                    <dl class="row border-bottom">
                        <dt class="col-lg-2 col-md-3">インフラ環境構築</dt>
                        <dd class="col-lg-10 col-md-9">
                            <div class="icon"><img src="../../assets/global-web/Globalsign_Logo.svg" width="201" height="42"></div>
                            <div class="icon"><img src="../../assets/global-web/GitHub_Emblem_Logo.svg" width="158" height="42"></div>
                            <div class="icon"><img src="../../assets/global-web/Amazon_Web_Services_Logo.svg" width="84" height="50"></div>
                        </dd>
                    </dl>
                    <dl class="row border-bottom">
                        <dt class="col-lg-2 col-md-3">Webサイト設計</dt>
                        <dd class="col-lg-10 col-md-9">
                            <div class="icon"><img src="../../assets/global-web/AEM_Logo.svg" width="156" height="89"></div>
                            <div class="icon"><img src="../../assets/global-web/Wordpress_Logo.svg" width="196" height="40"></div>
                            <div class="icon"><img src="../../assets/global-web/Shopify_Logo.svg" width="157" height="45"></div>
                            <div class="icon"><img src="../../assets/global-web/Magento_Logo.svg" width="171" height="50"></div>
                        </dd>
                    </dl>
                    <dl class="row border-bottom">
                        <dt class="col-lg-2 col-md-3">Webサイト解析</dt>
                        <dd class="col-lg-10 col-md-9">
                            <div class="icon"><img src="../../assets/global-web/Adobe_Analytics_Logo.svg" width="149" height="62"></div>
                            <div class="icon"><img src="../../assets/global-web/Google_Analytics_Logo.svg" width="139" height="48"></div>
                        </dd>
                    </dl>
                    <dl class="row">
                        <dt class="col-lg-2 col-md-3">Webサイト運用</dt>
                        <dd class="col-lg-10 col-md-9">
                            <div class="icon"><img src="../../assets/global-web/HubSpot_Logo.svg" width="153" height="45"></div>
                        </dd>
                    </dl>
                </div>
            </div>
        </section>
        <!-- Target Visualization -->
        <section class="target_visualization hover-anim" v-animate="'fade-in'">
            <div class="container border-bottom">
                <h5 class="sub_title">
                    <animation-sub-title :title="'日本のセキュリティ基準'" :id="'title-2'"/>
                </h5>
                <div class="img-area">
                    <img class="" src="../../assets/global-web/target_visualization.jpg" width="800" height="400" alt="ターゲットの可視化">
                </div>
                <p class="sub_content">企業認証型SSLでの常時SSL化、ワードプレスへのセキュリティパッチ、死活監視、ログ管理、<br/>
                    不要なアプリケーションの削除など日本本社から求められるセキュリティ基準を満たすのはローカルの企業では難しいことが多いのが現状です。<br/>
                    オロでは日本を含む数百人以上のエンジニアで御社のウェブサイトを安全に運用します。</p>
            </div>
        </section>
        <!-- Inbound -->
        <section class="inbound hover-anim" v-animate="'fade-in'">
            <div class="container">
                <h5 class="sub_title">
                    <animation-sub-title :title="'インバウンドセールス強化'" :id="'title-3'"/>
                </h5>
                <div class="img-area">
                    <img class="" src="../../assets/global-web/Inbound.png" width="1089" height="343" alt="インバウンドセールス強化">
                </div>
                <p class="sub_content">Hubspotを利用したChatbot、既存顧客へのメール配信は各国のローカル営業の強い味方になります。</p>
            </div>
        </section>
    </div>
</template>

<script>
import AnimationSubTitle from "../common/AnimationSubTitle";

export default {
    name: 'GlobalWebContent',
    components: {AnimationSubTitle},
    computed: {
        isMobile() {
            if (window.innerWidth <= 768) return true;
            if ('maxTouchPoints' in navigator) return navigator.maxTouchPoints > 0 ? true : false
            else return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        }
    },
}
</script>

<style lang="scss" scoped>
    .technical {
        > .container {
            padding-bottom: 0;
        }
        .sub_title {
            margin-bottom: 30px;
        }
        .sub_content {
            margin-top: 30px;
            margin-bottom: 20px;
        }
        .icon-list {
            margin-bottom: 0;
            dl {
                margin: 0;
                padding: 10px 0;
                dt {
                    display: flex;
                    align-items: center;
                    font-size:20px;
                    letter-spacing: 0.8px;
                    line-height: 34px;
                }
                dd {
                    display: flex;
                    flex-wrap: wrap;
                    .icon {
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        img {
                            padding: 0 6px;
                            margin-top: 55px;
                            margin-bottom: 55px;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 767px) {
        .service-page {
            .sub_title {
                margin-bottom: 40px;
            }
        }
        .technical {
            .sub_content {
                margin-bottom: 0;
            }
            .icon-list {
                dl {
                    margin-top: 55px;
                    margin-bottom: 55px;
                    padding-bottom: 30px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    dt {
                        display: block;
                        padding: 0;
                    }
                    dd {
                        padding: 15px 0;
                        margin-bottom: 0;
                        justify-content: space-between;
                        .icon {
                            width: 40%;
                            padding: 0;
                            img {
                                width: unset !important;
                                margin-top: 20px;
                                margin-bottom: 30px;
                                padding: 0;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
